'use strict';

module.exports = function zeroPad(val, digits) {
  while (val.length < digits) {
    val = '0' + val;
  }return val;
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/zero-pad.js
// module id = 1722
// module chunks = 0